//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SelectionIntentRule.js";
import "../no/SelectionIntentRule.js";
let d=[[],[[[],"Dispose",{},0,0],[["seed_curve","end_curve","from_seed_start","gap_tolerance"],"GetData",{},0,0]],[]];
SPLM.CurveChainRule = class extends SPLM.SelectionIntentRule{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CurveChainRule";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;